import React from 'react'

import { Paper, Box, Typography, Divider, Button } from '@material-ui/core'

import { Link, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'
import { routes } from 'routes'

const ContractSuspended = () => {
  const params = useParams()

  return (
    <Paper>
      <Box p={2}>
        <Typography variant="h4">Suspender assinatura</Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <Typography color="textSecondary">
          É possível suspender uma assinatura para que a cobrança seja
          interrompida por um determinado período.
        </Typography>
        <Box mt={2}>
          <Button
            component={Link}
            to={reverse(routes.contracts.suspend, {
              contractId: params.contractId,
            })}
            color="primary"
            variant="outlined"
          >
            Suspender assinatura
          </Button>
        </Box>
      </Box>
    </Paper>
  )
}

export default ContractSuspended
